import XarticlesForum  from './ts/XarticlesForum';

global.XarticlesForum = XarticlesForum;
